import { Injectable } from '@angular/core';
import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';

@Injectable()
export class CmsHelpService extends BaseService {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    getByUser(userId: number) {
        return this.http.get(`cmsHelp/${userId}`);
    }

    getByUserType(userType: FaqUserType) {
        return this.http.get(`cmsHelp/BidMgt/${userType}`);
    }

    getByBidType(userType: AboutBidManagementUserType) {
        return this.http.get(`cmsHelp/AboutBidMgt/${userType}`);
    }
}

export enum FaqUserType {
    BidManager = 100,
    BidTeamMember = 200,
    Free = 300
}

export enum AboutBidManagementUserType {
    BeforeFreeTrial = 100,
    FreeTrialStarted = 200,
    PaidTenders = 300,
    PaidFull = 400,
    TeamMember = 500,
    PaidFullBeforeBid = 600,
    BeforeFreeTrialValidated = 700,
    FreeTrialStartedNotValidated = 800
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/cms.help.service.ts